import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useWorkflowStore } from "./workflowStore";
import { SudoButton } from "src/sudokit/components/SudoButton";

function WorkflowList() {
  const workflows = useWorkflowStore((state) => Object.values(state.workflows));
  const systemWorkflows = workflows.filter((workflow) => workflow.isSystem);
  const userWorkflows = workflows.filter((workflow) => !workflow.isSystem);
  const createUserWorkflow = useWorkflowStore((state) => state.createUserWorkflow);
  const [creatingUserWorkflow, setCreatingUserWorkflow] = useState(false);
  const history = useHistory();

  return (
    <div className="flex flex-col items-start space-y-4 m-4 pb-10 bg-white justify-start">
      <p className="text-gray-500 mb-2">
        <a
          href="https://www.notion.so/sudowrite/Prompt-Framework-2037975fa0ec808d9303ddc0df9b2b00?source=copy_link"
          target="_blank"
        >
          Additional Documentation
        </a>{" "}
        on Notion
      </p>
      <h3 className="mb-2">Live</h3>
      <p className="text-gray-500 mb-2">These are prompts that are wired up and can control active inference. These require engineers to wired them into the system.</p>
      <ul className="space-y-2 justify-start">
        {systemWorkflows.map((workflow) => (
          <li
            key={workflow.id}
            className="text-gray-700 flex flex-col items-start justify-start"
          >
            <Link
              to={`/ai-functions/${workflow.id}`}
              className="hover:text-blue-600 flex flex-row gap-2 items-start justify-start"
            >
              {workflow.name || workflow.slug}

              {workflow.productionVersionId && <span className="text-green-600 font-bold"> Active</span>}
            </Link>
            {workflow.description && <p className="text-gray-500">{workflow.description}</p>}
          </li>
        ))}
      </ul>
      {userWorkflows.length > 0 && (
        <>
          <h3 className="mt-4 mb-2">Playground</h3>
          <p className="text-gray-500 mb-2">Prompts for experiments and troubleshooting.</p>
        </>
      )}
      <ul className="space-y-2">
        {userWorkflows.map((workflow) => (
          <li key={workflow.id}>
            <Link
              to={`/ai-functions/${workflow.id}`}
              className="hover:text-blue-600 flex flex-row gap-2 items-start justify-start"
            >
              {workflow.name || workflow.slug}
              {workflow.description && <p className="text-gray-500">{workflow.description}</p>}
            </Link>
          </li>
        ))}
      </ul>

      <SudoButton
        variant="primary"
        className="mt-4"
        onClick={async () => {
          setCreatingUserWorkflow(true);
          const workflow = await createUserWorkflow();
          setCreatingUserWorkflow(false);
          history.push(`/ai-functions/${workflow.id}`);
        }}
        disabled={creatingUserWorkflow}
      >
        New Prompt
      </SudoButton>
    </div>
  );
}

export default WorkflowList;
